<template>
  <div class="wrapper">
    <QuickTourOnBoarding />
    <DashboardAdminTop :dashboardInfo="groups" />
    <GroupsList :groups="groups" />
  </div>
</template>

<script>
import DashboardAdminTop from "@/components/dashboardAdmin/DashboardAdminTop.vue";
import GroupsList from "@/components/dashboardAdmin/GroupsList.vue";
import Api from "@/services/api";
import { mapState } from "vuex";
import { getAuthorizationToken } from "@/services/utils";
import QuickTourOnBoarding from "@/components/onBoarding/quickTourOnBoarding.vue";


export default {
  props: ["id"],
  components: { DashboardAdminTop, GroupsList, QuickTourOnBoarding },
  name: "SurveyResults",
  data() {
    return {
      respondents: 0,
      questions: [],
      areas: {},
      presentation_info: {},
      metrics: {},
      resultsModalData: [],
      groups: [],
    };
  },
  computed: {
    ...mapState(["currentUser"]),
  },
  methods: {},
  mounted() {
    Api().get("organizations/get_groups_by_area_and_manager", {
      params: {
        id: this.currentUser.organization_id
      },
      headers: {
        Authorization: getAuthorizationToken(),
      },
    })
    .then(res => {
      this.groups = res.data || [];
    })
    .catch((err) => {
      console.log(err);
    });
  },
};
</script>
<style lang="less" scoped>
</style>